import allMessages from './messages.json';

const messages = allMessages.en;

export default messages;
